module.exports = __webpack_public_path__ + "img/thm_logo.292cf2e8.svg";